export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const EDIT_CUSTOMER='EDIT_CUSTOMER';
